import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["hours", "otHours", "totalHours", "totalOtHours"];

  connect() {
    this.calculate();
  }

  calculate() {
    let hours = 0;
    let otHours = 0;

    this.hoursTargets.forEach((el) => {
      hours += parseFloat(el.value) || 0;
    });

    this.otHoursTargets.forEach((el) => {
      otHours += parseFloat(el.value) || 0;
    });

    this.totalHoursTarget.textContent = hours.toFixed(1);
    this.totalOtHoursTarget.textContent = otHours.toFixed(1);
  }
}
